import { Component } from '@angular/core';
import { UserService } from '../shared';

@Component({
  templateUrl: 'patient.component.html'
})
export class PatientComponent {
  public data: Object;

  constructor(
    private userService: UserService
  ) {
    if (window.localStorage['patpwd']) {
      window.localStorage.removeItem('patpwd');
    }
    if (window.localStorage['pwd']) {
      window.localStorage.removeItem('pwd');
    }

    if (window.localStorage['patid']) {
      window.localStorage.removeItem('patid');
    }
    if (window.localStorage['logopath']) {
      window.localStorage.removeItem('logopath');
    }
  }

  ngOnInit() {
    this.userService.getsession().subscribe(data => {
      if (data.item.userGroupId != 19 && data.item.userGroupId != 20) {
        window.localStorage.clear();
        location.href = "./404.html";
      }

    })
  }


}






